import { Label } from '../BaseComponents'

const NavigationCountIcon = ({ count }: { count: number }) => (
  <Label color="green" circular>
    {count}
  </Label>
)

export default NavigationCountIcon
